export default __webpack_public_path__ + "static/media/AVERY_5390.385cbf2f.png";